module.exports = __webpack_public_path__ + "font_genshin.984acf7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male/font_genshin.png
// module id = Qzez
// module chunks = 0